export const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <rect width="32" height="32" rx="16" fill="#EAECF1" fillOpacity="0.5" />
    <path
      d="M12.0181 9.32557C12.0181 10.1951 11.3774 10.8816 10.3248 10.8816C9.31797 10.8816 8.67725 10.1951 8.67725 9.32557C8.67725 8.45603 9.31797 7.76953 10.3248 7.76953C11.3774 7.76953 11.9724 8.45603 12.0181 9.32557ZM8.76878 22.2315V12.163H11.8808V22.2315H8.76878ZM13.803 15.3666C13.803 14.1309 13.7572 13.0783 13.7115 12.163H16.4116L16.5489 13.5818H16.5947C17.0066 12.9411 18.0134 11.9342 19.7068 11.9342C21.7662 11.9342 23.3222 13.3072 23.3222 16.2819V22.2315H20.2102V16.6481C20.2102 15.3666 19.7525 14.4513 18.6084 14.4513C17.7388 14.4513 17.2354 15.0463 17.0066 15.6412C16.9151 15.8243 16.9151 16.1447 16.9151 16.4192V22.2315H13.803V15.3666Z"
      fill="#383D48"
    />
  </svg>
)
